import { fetchWithAuth } from '../../../common/utils/apiUtils';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

export const fetchProjects = async () => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/projects`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
};

export const fetchProjectsSummary = async (filters = {}, page = 0, size = 10) => {
  try {
    const params = new URLSearchParams();
    if (filters.name) params.append('name', filters.name);
    if (filters.departamento) params.append('departamento', filters.departamento);
    if (filters.estado) params.append('estado', filters.estado);
    if (filters.certifierId) params.append('certifierId', filters.certifierId);
    params.append('page', page.toString());
    params.append('size', size.toString());

    const url = `${API_BASE_URL}/projects/list?${params.toString()}`;
    const response = await fetchWithAuth(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching projects summary:', error);
    throw error;
  }
};

export const fetchProjectById = async (id) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/projects/${id}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching project by ID:', error);
    throw error;
  }
};

export const createProject = async (projectData) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/projects`, {
      method: 'POST',
      body: JSON.stringify(projectData),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating project:', error);
    throw error;
  }
};

export const updateProject = async (id, projectData) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/projects/${id}`, {
      method: 'PUT',
      body: JSON.stringify(projectData),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating project:', error);
    throw error;
  }
};

export const fetchStatuses = async () => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/statuses`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching statuses:', error);
    throw error;
  }
};

export const fetchCertifiers = async () => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/certifiers`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching certifiers:', error);
    throw error;
  }
};

export const deleteProject = async (id) => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/projects/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return true;
  } catch (error) {
    console.error('Error deleting project:', error);
    throw error;
  }
};